import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  etaList: PropTypes.array.isRequired,
  onEtaChange: PropTypes.func.isRequired,
  currentEta: PropTypes.string,
  enabled: PropTypes.bool,
  errorMsg: PropTypes.string,
};

const defaultProps = {
  enabled: true,
  errorMsg: null,
  currentEta: null,
};

const EtaSwitch = ({ etaList, currentEta, onEtaChange, enabled, errorMsg }) => {
  const onChange = ({ currentTarget: { value } }) => onEtaChange(value);
  const mapETAIntoButton = (eta, i) => {
    const { value, label } = eta;

    return (
      <label
        htmlFor={`eta-${value}`}
        key={value}
        id={`eta-${value}-btn`}
        className={classNames('OrderDetailsLayout__eta_btn', 'btn', 'btn-default', {
          active: value === currentEta,
          'OrderDetailsLayout__eta_btn--disabled': !enabled,
        })}
      >
        <input
          onChange={onChange}
          type="radio"
          name={`eta-${value}`}
          id={`eta-${value}`}
          value={i}
          required
          checked={value === currentEta}
          disabled={!enabled}
        />
        {label}
      </label>
    );
  };

  const btnsClass = classNames('OrderDetailsLayout__actions_btns_text', {
    'OrderDetailsLayout__actions_btns_text--error': !!errorMsg,
  });

  return (
    <div>
      <div className={btnsClass}>
        <strong>
          <FormattedMessage id="ticket_eta" defaultMessage="Estimated time of arrival" />
        </strong>
      </div>
      <div className="OrderDetailsLayout__eta_btns_wrapper btn-group" data-toggle="buttons">
        {etaList.map(mapETAIntoButton)}
      </div>
      {errorMsg && <div className="OrderDetailsLayout__eta_error_msg">{errorMsg}</div>}
    </div>
  );
};

EtaSwitch.propTypes = propTypes;
EtaSwitch.defaultProps = defaultProps;

export default EtaSwitch;



// WEBPACK FOOTER //
// ../ui-components/components/EtaSwitch/index.jsx